module.exports = __webpack_public_path__ + "5f5757045850867d08f5736fdbfbf635.png";